import {
    IRequestMaterialStage,
    IRequestMaterialStagePositions,
} from '@entities/requestMaterial';

const matchesSearch = (name: string, search: string): boolean =>
    name.toLowerCase().includes(search.toLowerCase());

const filterPosition = (
    position: IRequestMaterialStagePositions,
    search: string
): IRequestMaterialStagePositions | null => {
    if (position.type === 'single') {
        return matchesSearch(position.name, search) ? position : null;
    }

    const filteredChildren = position.children.filter((child) =>
        matchesSearch(child.name, search)
    );

    return filteredChildren.length > 0 ? { ...position, children: filteredChildren } : null;
};

export const filterStages = (
    stages: IRequestMaterialStage[],
    search: string
): IRequestMaterialStage[] => {
    if (!search.trim()) return stages;

    return stages.reduce<IRequestMaterialStage[]>((acc, stage) => {
        const filteredPositions = stage.positions
            .map((position) => filterPosition(position, search))
            .filter((position): position is IRequestMaterialStagePositions => position !== null);

        if (filteredPositions.length > 0) {
            acc.push({ ...stage, positions: filteredPositions });
        }

        return acc;
    }, []);
};
